<template>
  <BTooltipButton
    :to="authorized ? logoutRoute : loginRoute"
    :tooltip="authorized ? 'Выход' : 'Вход'"
    class-button="nav__button nav__button-rounded no-margin"
    depressed
    bottom
    v-on="$listeners"
  >
    <template #button-inner>
      <span
        v-if="authorized"
        class="logout-icon"
        v-html="icon"
      />
      <v-icon
        v-else
        v-text="'mdi-login'"
      />
    </template>
  </BTooltipButton>
</template>
<script>
import { AUTH_ROUTES } from '@/views/Auth/utils'
import BTooltipButton from '@/components/common/BTooltipButton.vue'


export default {
  name: 'LKHeaderAuthLink',
  components: {
    BTooltipButton,
  },
  props: {
    authorized: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    loginRoute: { name: AUTH_ROUTES.LOGIN },
    logoutRoute: { name: AUTH_ROUTES.LOGOUT },
    icon: null,
  }),
  async created() {
    this.icon = (await import(
      '!raw-loader!@/../public/images/logout.svg'
    )).default
  },
}
</script>

<style>
.logout-icon,
.logout-icon svg {
  height: 1rem;
}
</style>
